import { render, staticRenderFns } from "./ListStatistics.vue?vue&type=template&id=4c3a394c&scoped=true&"
import script from "./ListStatistics.vue?vue&type=script&lang=js&"
export * from "./ListStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ListStatistics.vue?vue&type=style&index=0&id=4c3a394c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3a394c",
  null
  
)

export default component.exports